import React from 'react'
import { Container } from './ShelfLoading.styles'
import SpinnerLoader from 'components/loader'

export type ShelfLoadingProps = {
  height: number
}

const ShelfLoading: React.FC<ShelfLoadingProps> = props => {
  return (
    <Container data-testid="loading" {...props}>
      <SpinnerLoader />
    </Container>
  )
}

export default ShelfLoading
